import { mixed, object, ObjectSchema } from 'yup';
import { ERRORS } from '@/configs/codes';
import { FILE_VALIDATORS } from '@/configs/validator';
import {
    getDisplayMimeTypes,
    validateFileSize,
    validateFileType,
} from '@/helpers/validate';
import { GallerySourceFormDataIF } from '@/components/forms/GallerySourceForm/GallerySourceForm.types';

export const schema: ObjectSchema<GallerySourceFormDataIF> = object({
    images: mixed<FileList>()
        .required(ERRORS.er200)
        .nullable()
        .defined()
        .default(null)
        .test(
            'maxSize',
            `${ERRORS.er215} Максимальный размер: ${FILE_VALIDATORS.image.maxSize}мб.`,
            (value) => validateFileSize('image', value),
        )
        .test(
            'mimeType',
            `${ERRORS.er216} Допустимые типы: ${getDisplayMimeTypes(FILE_VALIDATORS.image.accept).join(', ')}`,
            (value) => validateFileType('image', value),
        )
        .test(
            'maxCount',
            `Максимум ${FILE_VALIDATORS.image.maxFilesCount} файлов`,
            (value) =>
                !!value && value.length <= FILE_VALIDATORS.image.maxFilesCount,
        ),
});
